import styled from "styled-components";
import { Link } from "react-scroll";

export const ListWrapper = styled.section`
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 0px 40px;
    padding-bottom: 40px;

        @media (max-width: 768px) {
        padding: 0px 20px;
}
`;

export const List = styled.ul`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: stretch;
    grid-gap: 32px;
    list-style: none;
    padding: 0;
    margin: 0 auto;
    max-width: 85%;

    @media (max-width: 991px) {
        grid-template-columns: 1fr;
        grid-gap: 24px;
    }
`;

export const Tile = styled.li`
    margin: 0;
`;

export const TileLink = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 30px 20px;
  border-radius: 10px;
  border: 2px solid rgb(240, 240, 240);
  box-shadow: 0 0 20px rgba(0,0,0,0.1);

  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  &:focus-visible {
    outline: 3px solid rgba(0,0,0,0.35);
    outline-offset: 4px;
  }

  @media (max-width: 768px) {
    padding: 30px;
  }
`;

export const Name = styled.h3`
    font-weight: 700;
    font-size: 24px;
    margin: 0;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

export const Description = styled.p`
    font-size: 18px;
    margin-bottom: 0;
    line-height: 1.4;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;
